// extracted by mini-css-extract-plugin
export default {"menu":"TeamChatDetailMenuList_menu_alyLM","margin_36":"TeamChatDetailMenuList_margin_36_GudTo"};